import { motion } from 'framer-motion';
import { fadeUp, viewportOnce } from '@/lib/motion';

export default function SectionHead({ chapter, eyebrow, title, description, testId }) {
  return (
    <div className="mb-14 sm:mb-20 max-w-4xl" data-testid={testId}>
      <motion.div
        variants={fadeUp} initial="hidden" whileInView="show" viewport={viewportOnce}
        className="flex items-center gap-4 mb-5"
      >
        <span className="font-display text-3xl sm:text-4xl text-stroke-gold leading-none">{chapter}</span>
        <span className="h-px w-12 bg-brand-gold/50" />
        <span className="text-xs sm:text-sm uppercase tracking-[0.3em] text-brand-gold font-semibold">{eyebrow}</span>
      </motion.div>
      <motion.h2
        variants={fadeUp} custom={1} initial="hidden" whileInView="show" viewport={viewportOnce}
        className="font-display uppercase tracking-tight leading-[0.95] text-4xl sm:text-5xl lg:text-6xl text-white whitespace-pre-line"
      >
        {title}
      </motion.h2>
      {description && (
        <motion.p
          variants={fadeUp} custom={2} initial="hidden" whileInView="show" viewport={viewportOnce}
          className="mt-6 text-base sm:text-lg text-gray-400 leading-relaxed max-w-2xl"
        >
          {description}
        </motion.p>
      )}
    </div>
  );
}
